import { Button } from '@sunwebgroup/uds-ui/button'
import { Menu } from '@sunwebgroup/uds-ui/menu'
import React, { memo, useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { useUserReviews } from '@/scopes/products/user-reviews/hooks'
import { createUserReviewsEvent } from '@/scopes/products/user-reviews/infrastructure/analytics'
import styles from './SortingSelect.module.css'

const SORT_OPTIONS = [
  {
    id: '-date',
    translation: 'reviews_sort_option_most_recents',
  },
  {
    id: 'date',
    translation: 'reviews_sort_option_less_recents',
  },
  {
    id: '-rating',
    translation: 'reviews_sort_option_higher_score_to_lower',
  },
  {
    id: 'rating',
    translation: 'reviews_sort_option_lower_score_to_higher',
  },
]

export const SortingSelect = memo(() => {
  const intl = useIntl()
  const { sorting, setSorting } = useUserReviews()
  const [open, setOpen] = React.useState(false)
  const { sendEvent } = useAnalytics()
  const getResultSorting: Record<string, string> = {
    '-date': 'Most recent',
    'date': 'Least recent',
    '-rating': 'Highest score to lowest',
    'rating': 'Lowest score to highest',
  }

  function toggle() {
    setOpen(!open)
  }

  const handleChangeSorting: React.ChangeEventHandler<HTMLSelectElement> = useCallback(
    (e) => {
      sendEvent(
        createUserReviewsEvent({
          description: 'sort reviews',
          element: 'Dropdown',
          result: getResultSorting[e.target.value],
        }),
      )
      setSorting(e.target.value)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sendUserReviewsEvent is a stable function
    [setSorting],
  )

  return (
    <Menu.Root open={open} onOpenChange={toggle}>
      <Menu.Trigger>
        <Button variant="transparentNeutral">
          {intl.formatMessage({ id: SORT_OPTIONS.find(option => option.id === sorting)?.translation })}
          <Button.Icon glyph={open ? 'ChevronUpExtraSmall' : 'ChevronDownExtraSmall'} />
        </Button>
      </Menu.Trigger>
      <Menu.Content className={styles.menuContent}>
        {SORT_OPTIONS.map(option => (
          <Menu.Item
            key={option.id}
            glyph={option.id === sorting ? 'CheckMark' : undefined}
            onSelect={() => handleChangeSorting({ target: { value: option.id } } as any)}
          >
            {intl.formatMessage({ id: option.translation })}
          </Menu.Item>
        ))}
      </Menu.Content>
    </Menu.Root>
  )
})

SortingSelect.displayName = 'SortingSelect'
